export const VERSION = '5.0.0-dev';
//# sourceMappingURL=pkg-version.js.map